<template>
  <div class="body">
    <!-- 筛选 -->
    <div class="form bg-white p20 mb30">
      <el-form ref="form" :model="form"   @submit.native.prevent label-width="80px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="培训项目" prop="trainingName">
              <el-input v-model="form.trainingName" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="地点" prop="location">
              <el-input v-model="form.location" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="部门" prop="associationId">
              <selectTree
                clearable
                ref="selectTree"
                :props="{
                  value: 'id', // ID字段名
                  label: 'text', // 显示名称
                  children: 'children' // 子级字段名
                }"
                :options="deptTree"
                :value="form.associationId"
                @getValue="selectTreeChange"
              ></selectTree>
              <!-- <el-select v-model="form.associationName" placeholder="请选择">
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.deptName"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="教学方式" prop="teachingMethods">
              <el-select clearable v-model="form.teachingMethods" placeholder>
                <el-option
                  v-for="(item, index) in teaching_methods"
                  :key="index"
                  :label="item.text"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" class="pr20">
            <el-form-item label="开始时间" prop="date">
              <el-date-picker
                v-model="form.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="searchBut">
          <el-form-item>
            <el-button @click="search" type="primary">搜索</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="$router.push(`/trainingManagement/addLatoja`)"
            >新增
            </el-button
            >
            <!-- <el-button @click="exportFile">导出</el-button> -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 培训记录列表 -->
    <div class="bg-white p20 pb50">
      <el-table
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        class="mb20"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          fixed
          type="index"
          width="60"
          label="序号"
        ></el-table-column>
        <el-table-column prop="trainingName" label="培训项目"></el-table-column>
        <el-table-column prop="createName" label="创建人"></el-table-column>
        <el-table-column prop="associationName" label="部门"></el-table-column>
        <el-table-column prop="location" label="地点"></el-table-column>
        <el-table-column
          prop="teachingMethodsStr"
          label="教学方式"
        ></el-table-column>
        <el-table-column
          prop="trainingStartTime"
          label="开始时间"
        ></el-table-column>
        <el-table-column
          prop="trainingEndTime"
          label="结束时间"
        ></el-table-column>
        <el-table-column
          prop="programNumber"
          label="计划人数"
        ></el-table-column>
        <el-table-column prop="actualNumber" label="实到人数"></el-table-column>
        <el-table-column fixed="right" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="
                $router.push(
                  `/trainingManagement/detailLatoja?type=check&id=${scope.row.id}`
                )
              "
            >查看
            </el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="
                $router.push(
                  `/trainingManagement/updateLatoja?type=edit&id=${scope.row.id}`
                )
              "
            >编辑
            </el-button
            >
            <el-button size="mini" type="danger" @click="delItem(scope.row.id)"
            >删除
            </el-button
            >
            <el-button
              size="mini"
              type="warning"
              v-if="!scope.row.summaryId"
              @click="addSummary(scope.$index)"
            >添加总结
            </el-button
            >
            <el-button
              v-else
              size="mini"
              type="success"
              @click="lookSummary(scope.$index)"
            >查看总结
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;"
        background
        layout="total ,prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        @current-change="pageChange"
      ></el-pagination>
    </div>
    <!-- 添加总结 -->
    <el-dialog
      @close="closeDialog"
      title="添加总结"
      :visible.sync="addSummaryVisible"
      width="70%"
    >
      <el-form
        v-if="list.length > 0"
        ref="summaryForm"
        :model="summaryForm"
        label-width="120px"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="培训项目">
              <el-input
                v-model="list[selectIndex].trainingName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="地点">
              <el-input
                v-model="list[selectIndex].location"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="培训讲师">
              <el-input v-model="list[selectIndex].trainer" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="讲师资质">
              <el-input
                v-model="list[selectIndex].trainerCondition"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="计划人数">
              <el-input
                v-model="list[selectIndex].programNumber"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="实到人数">
              <el-input
                v-model="list[selectIndex].actualNumber"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="教材" prop="textbook">
              <el-input
                :disabled="isLooksummary"
                v-model="summaryForm.textbook"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="评价形式" prop="evaluationForm">
              <el-input
                :disabled="isLooksummary"
                v-model="summaryForm.evaluationForm"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训时段" prop="date">
              <el-input
                disabled
                :value="
                  `${list[selectIndex].trainingStartTime} 至 ${list[selectIndex].trainingEndTime}`
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训总结" prop="trainningSummary">
              <el-input
                :disabled="isLooksummary"
                v-model="summaryForm.trainningSummary"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="培训效果追踪评价" prop="dataIntroduction">
              <el-input
                :disabled="isLooksummary"
                v-model="summaryForm.trainningEvaluationa"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="培训类别" prop="trainningCategory">
              <el-checkbox-group
                :disabled="isLooksummary"
                v-model="summaryForm.trainningCategory"
              >
                <el-checkbox label="0">宣贯类</el-checkbox>
                <el-checkbox label="1">考核类</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="10">
            <el-form-item label="教学方式" prop="teachingMethods">
              <el-checkbox-group disabled v-model="summaryForm.teachingMethods">
                <el-checkbox
                  :label="item.id"
                  v-for="(item, index) in teaching_methods"
                  :key="index"
                >{{ item.text }}
                </el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="10">
          <el-form-item>
            <el-button v-show="!isLooksummary" type="primary" @click="save">保存</el-button>
            <el-button v-show="isLooksummary" type="primary" @click="exportFile">导出</el-button>
          </el-form-item>
        </el-col>
      </el-form>
      <div style="height:150px;"></div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * {"recordId":"记录id",
 * "trainningCategory":"培训类别(0;宣贯类 1;考核类) int",
 * "teachingMethods":"教学方式",
 * "textbook":"教材",
 * "evaluationForm":"评价形式",
 * "trainningSummary":"培训总结",
 * "trainningEvaluationa":"培训效果追踪",
 * "trainningSummaryLocation":"培训总结路径"
}
 */
import training from "@/api/new/training";
import util from "../../common/util";
import selectTree from "@/components/common/selectTree";

export default {
  components: {selectTree},
  data() {
    return {
      tableLoading: false,
      list: [],
      addSummaryVisible: false,
      form: {
        date: [],
        trainingName: undefined,
        location: undefined,
        associationId: undefined,
        createdBy: undefined,
        trainingStartTime: undefined,
        trainingEndTime: undefined,
        teachingMethods: undefined
      },
      page: 1,
      pageSize: 10,
      total: 0,
      departmentList: [],
      deptTree: [],
      teaching_methods: [],
      summaryForm: {
        recordId: undefined,
        trainningCategory: [],
        teachingMethods: [],

        textbook: undefined,
        evaluationForm: undefined,
        trainningSummary: undefined,
        trainningEvaluationa: undefined,
        trainningSummaryLocation: undefined
      },
      selectIndex: 0,
      isLooksummary: false
    };
  },
  mounted() {
    // this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.teaching_methods = JSON.parse(
      localStorage.getItem("teaching_methods")
    );
    this.search();
  },
  methods: {
    selectTreeChange(v) {
      v.id ? this.form.associationId = parseInt(v.id) : this.form.associationId = undefined;
    },
    closeDialog() {
      this.summaryForm = {
        recordId: undefined,
        trainningCategory: [],
        teachingMethods: [],
        textbook: undefined,
        evaluationForm: undefined,
        trainningSummary: undefined,
        trainningEvaluationa: undefined,
        trainningSummaryLocation: undefined
      };
    },
    save() {
      let p = {
        ...this.summaryForm
      };
      p.recordId = this.list[this.selectIndex].id;
      p.trainningCategory = p.trainningCategory.join(",") || undefined;
      p.teachingMethods = p.teachingMethods.join(",") || undefined;

      training.summary(p).then(res => {
        if (res.code == 0) {
          setTimeout(() => {
            this.getOfflineList();
          }, 1000);
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
        this.addSummaryVisible = false;
      });
    },
    addSummary(index) {
      this.addSummaryVisible = true;
      this.selectIndex = index;
      this.isLooksummary = false;
      this.list[this.selectIndex].teachingMethods.split(",").forEach(v => {
        this.summaryForm.teachingMethods.push(Number(v));
      });
      this.summaryForm.teachingMethods.forEach(v => {
        v = parseInt(v);
      });
    },
    lookSummary(index) {
      this.addSummaryVisible = true;
      this.selectIndex = index;
      this.isLooksummary = true;
      this.list[this.selectIndex].teachingMethods.split(",").forEach(v => {
        this.summaryForm.teachingMethods.push(Number(v));
      });
      this.summaryForm.teachingMethods.forEach(v => {
        v = parseInt(v);
      });

      training
        .getSummary({
          summaryId: this.list[index].summaryId
        })
        .then(res => {
          this.summaryForm.textbook = res.data.textbook;
          this.summaryForm.evaluationForm = res.data.evaluationForm;
          this.summaryForm.trainningSummary = res.data.trainningSummary;
          this.summaryForm.trainningEvaluationa = res.data.trainningEvaluationa;
          if (res.data.trainningCategory) {
            this.summaryForm.trainningCategory = res.data.trainningCategory.split(
              ","
            );
          }
        });
    },
    delItem(recodId) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        training.delRecod({recodId}).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getOfflineList();
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      });
    },
    search(){
      this.page = 1;
      this.getOfflineList();
    },
    getOfflineList() {
      let p = {
        ...this.form,
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };

      if (p.date.length > 0) {
        p.trainingStartTime = p.date[0];
        p.trainingEndTime = p.date[1];
      }
      delete p.date;


      this.tableLoading = true;
      training.getOfflineList(p).then(res => {
        res.data.records.forEach(v => {
          let str = "";
          let temp = v.teachingMethods.split(",");
          temp.forEach(v2 => {
            this.teaching_methods.forEach(v3 => {
              if (v2 == v3.id) str += `  ${v3.text}  `;
            });
          });
          v.teachingMethodsStr = str;
        });

        this.list = res.data.records;
        this.total = res.data.total;

        this.tableLoading = false;
      });
    },
    pageChange(e) {
      this.page = e;
      this.getOfflineList();
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.$refs["selectTree"].clearHandle();
        this.search();
      });
    },
    selectionChange(e) {
      console.log(e);
    },
    exportFile() {
      training
        .exportSummary({
          id: this.list[this.selectIndex].summaryId
        })
        .then(res => {
          util.downloadBlobFile(res, "培训总结.docx");
        });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/latojaManagement.vue